import { render, staticRenderFns } from "./EmailPage.vue?vue&type=template&id=f3a1a036&scoped=true&"
import script from "./EmailPage.vue?vue&type=script&lang=js&"
export * from "./EmailPage.vue?vue&type=script&lang=js&"
import style0 from "./EmailPage.vue?vue&type=style&index=0&id=f3a1a036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a1a036",
  null
  
)

export default component.exports